import { Chip, Grid, Stack, Typography } from "@mui/material";

import { ManagementWidgetShell, StepPipelineList } from "./managementDashboardWidgets";

const MehrsanOverviewSection = ({ loading, error, data, onRetry }) => {
  const steps = data?.steps || data?.Steps || [];
  const cards = [
    ["مهرسان تکمیل", data?.mehrsanComplete ?? data?.MehrsanComplete],
    ["مهرسان ناقص", data?.mehrsanIncomplete ?? data?.MehrsanIncomplete],
    ["وارد نشده", data?.notEnteredMehrsan ?? data?.NotEnteredMehrsan],
    ["وام کامل / مهرسان ناقص", data?.loanCompleteMehrsanIncomplete ?? data?.LoanCompleteMehrsanIncomplete],
    ["مهرسان کامل / وام ناقص", data?.mehrsanCompleteLoanIncomplete ?? data?.MehrsanCompleteLoanIncomplete],
    ["معطل", data?.currentlyOverdue ?? data?.CurrentlyOverdue],
  ];

  return (
    <ManagementWidgetShell
      title="نمای کلی مهرسان"
      subheader="۴ مرحله کانونیکال LM_STAGE_STEP|mehrsan|*"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Grid container spacing={1} sx={{ mb: 2 }}>
        {cards.map(([label, value]) => (
          <Grid item xs={6} md={4} key={label}>
            <Chip label={`${label}: ${value ?? 0}`} sx={{ width: "100%", justifyContent: "flex-start" }} />
          </Grid>
        ))}
      </Grid>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        خط لوله ۴ مرحله‌ای مهرسان
      </Typography>
      <StepPipelineList steps={steps} />
    </ManagementWidgetShell>
  );
};

export default MehrsanOverviewSection;
